import React, { useEffect, useState } from 'react';

import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';

import LoadingScreen from 'src/components/LoadingScreen';

import { useData } from 'src/contexts/data';
import { ModelOfDemand } from 'src/database';
import { useDemandServiceListController } from 'src/controllers/DemandService/ListDemandServiceController';
import DemandServiceCard from 'src/components/Cards/DemandCard/DemandServiceCard';

import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { useHistory } from 'react-router-dom';
import PrintDemand from 'src/controllers/Demands/PrintDemand';

const SendedDemandsList: React.FC = () => {
    const { getDemandListController } = useDemandServiceListController();
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const { handleSelectedDemand } = useData();
    const { printCall } = PrintDemand();
    const { sendToPrint } = printCall;

    const history = useHistory();

    if (getDemandListController.loading) {
        return <LoadingScreen />;
    }

    const handleFilter = (demandsList: ModelOfDemand[]) => {
        return demandsList.filter(demand => demand.DESCRICAO?.toUpperCase().includes(globalFilter?.toUpperCase()));
    };

    const leftDemandToolbar = () => {
        return (
            // eslint-disable-next-line no-restricted-globals
            <Link to={{ pathname: '/DemandForm', state: { prevPath: history.location.pathname } }}>
                <Button label='Nova demanda' icon='pi pi-plus' className='p-button-success p-mr-2' />
            </Link>
        );
    };

    function sortByDate(a: any, b: any) {
        if (a.DATA < b.DATA) {
            return 1;
        }
        if (a.DATA > b.DATA) {
            return -1;
        }
        return 0;
    }

    if (getDemandListController.demandsData.length) {
        getDemandListController.demandsData.sort(sortByDate);
    }

    return (
        <div className='p-card p-p-4 datatable-container'>
            <Toast ref={getDemandListController.toast} />
            <div className='service-header p-grid'>
                <Toolbar className='p-mb-4' left={leftDemandToolbar}></Toolbar>

                <h5 className='p-m-0'>Demandas</h5>
                <span className='p-input-icon-left p-search-bar'>
                    <i className='pi pi-search' />
                    <InputText
                        type='search'
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)}
                        placeholder='Filtrar por Descricao'
                    />
                </span>
            </div>

            {getDemandListController.demandsData.length ? (
                handleFilter(getDemandListController.demandsData).map(demand => {
                    return (
                        <DemandServiceCard demand={demand} key={demand.ID} handleClick={() => sendToPrint(demand)} />
                    );
                })
            ) : (
                <h5>Nenhum resultado encontrado!</h5>
            )}
        </div>
    );
};

export default SendedDemandsList;
